export enum EquipmentOutfitReadinessRatingEnum {
  JobReadyLoadout = 1,
  NeedsAdditionalTooling = 2,
  NotJobReady = 3,
}
